<template>
  <el-dialog
    :title="this.id ? '修改设备系列' : '新增设备系列'"
    @close="handleCancle"
    @closed="reset"
    :close-on-click-modal="false"
    :visible="visible"
    width="560px"
  >
    <el-form
      ref="seriesForm"
      v-loading="loading"
      :model="seriesForm"
      :rules="typeFormRules"
      label-width="110px"
    >
      <el-row>
        <el-col :span="24">
          <el-form-item label="所属设备品牌" prop="deviceTypeAndBrandId">
            <!-- <el-input
              v-if="!isDetail"
              v-model="seriesForm.deviceTypeAndBrandId"
              :maxlength="50"
              placeholder="请输入"
            ></el-input>
            <span v-else>{{ seriesForm.deviceTypeAndBrandId }}</span> -->
            <el-cascader
              ref="brandTree"
              :key="brandTreeIndex"
              style="width: 100%"
              v-loading="treeLoading"
              v-model="seriesForm.deviceTypeAndBrandId"
              @change="brandChange"
              :options="deviceBrandTree"
              separator="-"
            ></el-cascader>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="系列名称" prop="seriesName">
            <!-- <el-input
              v-if="!isDetail"
              v-model="seriesForm.seriesName"
              :maxlength="50"
              placeholder="请输入"
            ></el-input>
            <span v-else>{{ seriesForm.seriesName }}</span> -->
            <el-input
              v-model="seriesForm.seriesName"
              :maxlength="50"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="系列编码" prop="seriesNo">
            <!-- <el-input
              v-if="!isDetail"
              :maxlength="50"
              v-model="seriesForm.seriesNo"
              placeholder="请输入"
            ></el-input>
            <span v-else>{{ seriesForm.seriesNo }}</span> -->
            <el-input :maxlength="50" v-model="seriesForm.seriesNo" placeholder="请输入"></el-input>
            <NoTips />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="状态" prop="status">
            <!-- <el-radio-group v-if="!isDetail" v-model="seriesForm.status">
              <el-radio :label="0">启用</el-radio>
              <el-radio :label="1">停用</el-radio>
            </el-radio-group>
            <span v-else>{{ seriesForm.status }}</span> -->
            <el-radio-group v-model="seriesForm.status">
              <el-radio v-for="(item, index) in statusType" :key="index" :label="item.typeNum">{{
                item.typeName
              }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-form-item v-loading="paraMeterloading" label="参数" prop="functionList">
          <!-- <el-radio-group v-if="!isDetail" v-model="seriesForm.status">
              <el-radio :label="0">启用</el-radio>
              <el-radio :label="1">停用</el-radio>
            </el-radio-group>
            <span v-else>{{ seriesForm.status }}</span> -->
          <template v-if="seriesForm.deviceTypeAndBrandId.length">
            <el-checkbox-group
              v-if="parameterList.length && !paraMeterloading"
              v-model="seriesForm.functionList"
            >
              <el-col :span="8" v-for="item in parameterList" :key="item.id">
                <el-checkbox :label="item.id">
                  <Ellipsis :texts="item.functionName" :length="12" />
                </el-checkbox>
              </el-col>
            </el-checkbox-group>
            <span v-if="!parameterList.length && !paraMeterloading">该设备类型下暂无参数</span>
          </template>
          <!-- <span v-else></span> -->
        </el-form-item>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleCancle">取消</el-button>
      <el-button type="primary" :loading="btnLoading" @click="handleSubmit">确定</el-button>
    </span>
    <ValidatPass ref="validatPass" @back="validateBack" />
  </el-dialog>
</template>
<script>
import { cloneDeep } from 'lodash';
import Ellipsis from '@/components/Ellipsis';
import deviceBrandApi from 'api/home/device-mangement/device-brand';
import deviceSeriesApi from 'api/home/device-mangement/device-series';
import deviceParameterApi from 'api/home/device-mangement/device-parameter';
import regex from '@/config/regex';
import statusType from '@/config/status';
import NoTips from '../device-components/NoTips';
import ValidatPass from '@/components/PermissionPassword/ValidatPass';
export default {
  components: {
    ValidatPass,
    NoTips,
    Ellipsis
  },
  data() {
    const validateNo = (rule, value, callback) => {
      const { noReg } = regex;
      if (!value) {
        callback(new Error('请输入设备系列编码'));
        return;
      }
      if (!noReg.test(value)) {
        callback(new Error('请用拼音或相应英文设置编码，以"_"或"-"进行连接'));
      } else {
        callback();
      }
    };
    return {
      statusType,
      brandTreeIndex: 0,
      id: '',
      loading: false,
      isDetail: false,
      visible: false,
      btnLoading: false,
      treeLoading: false,
      deviceBrandTree: [],
      parameterList: [],
      paraMeterloading: false,
      seriesForm: {
        deviceTypeAndBrandId: [],
        seriesName: '',
        seriesNo: '',
        functionList: [],
        status: 0
      },
      typeFormRules: {
        deviceTypeAndBrandId: [{ required: true, message: '请选择设备品牌', trigger: 'change' }],
        seriesName: [{ required: true, message: '请输入设备系列名称', trigger: 'blur' }],
        seriesNo: [{ required: true, validator: validateNo, trigger: 'blur' }],
        status: [{ required: true, message: '请选择状态', trigger: 'change' }]
      }
    };
  },
  methods: {
    init(data) {
      this.visible = true;
      this.brandTreeIndex = 0;
      this.getBrandTree();
      this.id = data.id || '';
      this.id && this.getSeriesDetail();
    },
    handleCancle() {
      this.visible = false;
    },
    handleSubmit() {
      this.$refs.seriesForm.validate(validated => {
        if (!validated) {
          return;
        }
        if (this.id) {
          this.editType();
        } else {
          this.addType();
        }
      });
    },
    addType() {
      const data = {
        deviceTypeId: this.seriesForm.deviceTypeAndBrandId.slice(-1)[0],
        seriesName: this.seriesForm.seriesName,
        seriesNo: this.seriesForm.seriesNo,
        status: this.seriesForm.status,
        functionList: this.seriesForm.functionList
      };
      this.btnLoading = true;
      deviceSeriesApi
        .addDeviceSeries(data)
        .then(res => {
          if (res.data.code !== 200) {
            return;
          }
          this.$message.success('新增设备系列成功');
          this.$emit('back', 0);
          this.pushVisible = true;
          this.visible = false;
        })
        .finally(() => {
          this.btnLoading = false;
        });
    },
    editType() {
      const data = {
        id: this.id,
        deviceTypeId: this.seriesForm.deviceTypeAndBrandId.slice(-1)[0],
        seriesName: this.seriesForm.seriesName,
        seriesNo: this.seriesForm.seriesNo,
        status: this.seriesForm.status,
        functionList: this.seriesForm.functionList
      };
      this.$refs.validatPass.init(data, 13, true);
    },
    getSeriesDetail() {
      this.loading = true;
      deviceSeriesApi
        .getDeviceSeriesDetail({ id: this.id })
        .then(res => {
          const {
            data: { data, code }
          } = res;
          if (code !== 200) {
            return;
          }
          const { deviceCategoryId, deviceTypeId, seriesName, seriesNo, status, deviceFunction } =
            data;
          this.getParameterList(deviceCategoryId);
          this.$nextTick(() => {
            this.seriesForm = {
              deviceTypeAndBrandId: [deviceCategoryId, deviceTypeId],
              seriesName: seriesName,
              seriesNo: seriesNo,
              functionList: deviceFunction.filter(item => item.checked).map(item => item.id),
              status: status
            };
          });
        })
        .finally(() => {
          this.$nextTick(() => {
            this.loading = false;
          });
        });
    },
    getBrandTree() {
      this.treeLoading = true;
      deviceBrandApi
        .getDeviceBrandTree()
        .then(res => {
          let { data } = res.data;
          this.deviceBrandTree = this.treeInit(data).filter(item => {
            return item.children;
          });
        })
        .finally(() => {
          this.$nextTick(() => {
            this.treeLoading = false;
          });
        });
    },
    getParameterList(id) {
      this.paraMeterloading = true;
      this.parameterList = [];
      deviceParameterApi
        .getDeviceParameterByType({ categoryId: id })
        .then(res => {
          const {
            data: { code, data }
          } = res;
          if (code !== 200) {
            return;
          }
          this.parameterList = data;
        })
        .finally(() => {
          this.$nextTick(() => {
            this.paraMeterloading = false;
          });
        });
    },
    brandChange(val) {
      if (val && val.length) {
        this.getParameterList(val[0]);
        this.seriesForm.functionList = [];
      }
    },
    treeInit(data) {
      data = data.filter(item => {
        return !item.disabled;
      });
      data = data.map(item => {
        let obj = {
          value: item.id,
          label: item.name
        };
        if (item.children && item.children.length) {
          obj.children = this.treeInit(item.children);
        }
        return obj;
      });
      return data;
    },
    validateBack() {
      this.$message.success('设备系列修改成功');
      this.$emit('back', 1);
      this.visible = false;
    },
    reset() {
      this.$refs.seriesForm.resetFields();
      // 初始化级联选择器
      this.brandTreeIndex++;
      this.btnLoading = false;
      this.paraMeterloading = false;
      this.parameterList = [];
      this.deviceBrandTree = [];
      this.id = '';
      this.isDetail = false;
    }
  }
};
</script>